import React, { useState, useEffect } from 'react';

const AnswerOption = ({idx, quizOption, selected, setSelectedId, answeredForTheDay}) => {

  const { answer, id } = quizOption;

  const uncheckedRadio = (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="1" width="15" height="15" rx="7.5" fill="white"/>
        <rect x="0.5" y="1" width="15" height="15" rx="7.5" stroke="#D0D5DD"/>
    </svg>
  )

  const checkedRadio = (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="#E1F6FE"/>
      <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#0096B7"/>
      <circle cx="8" cy="8" r="3" fill="#0096B7"/>
    </svg>
  )

  const handleClick = () => {
    if (!answeredForTheDay) {
      setSelectedId(id);
    }
  }

  return (
    <div
      className={selected ? 'answer-container selected' : 'answer-container'}
      onClick={handleClick}
      style={{ pointerEvents: answeredForTheDay ? 'none' : 'auto', opacity: answeredForTheDay ? 0.5 : 1 }}
    >
      <label htmlFor={`${idx}`}>
        <p className='answer-text'>{answer}</p>
        <input
          id={`${idx}`}
          type='radio'
          className='answer-input'
          onChange={() => setSelectedId(id)}
        />
        <label htmlFor={`${idx}`} className="radio-label">
          {selected ? checkedRadio : uncheckedRadio}
        </label>
      </label>
    </div>
  )
};

export default AnswerOption;